import React from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataMission } from '../../../data/modules/mission-header';
import DecompteValidationTable from './DecompteValidationTable';

const DecompteValidation = () => {
  return (
    <MainContainer {...headerDataMission}>
      <DecompteValidationTable />
    </MainContainer>
  );
};

export default DecompteValidation;
